import { ref, computed } from 'vue'
import { useMouseInElement } from '@vueuse/core'

export function useTilt(maxDeg = 10) {
  const target = ref(null)
  const { elementX, elementY, elementWidth, elementHeight, isOutside } = useMouseInElement(target)

  const rx = computed(() => {
    if (!elementWidth.value || isOutside.value) return 0
    const py = elementY.value / elementHeight.value
    return -(py - 0.5) * (maxDeg * 2)
  })

  const ry = computed(() => {
    if (!elementWidth.value || isOutside.value) return 0
    const px = elementX.value / elementWidth.value
    return (px - 0.5) * (maxDeg * 2)
  })

  const styleVars = computed(() => ({
    '--rx': rx.value + 'deg',
    '--ry': ry.value + 'deg',
  }))

  return { target, rx, ry, styleVars }
}
